import React from "react";
import styled from "styled-components";
import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import { SimpleTextArea } from "../../../SimpleTextArea/SimpleTextArea";

// newSeoProduct={newSeoProduct}
// setSeoProduct={setSeoProduct}

// TitleSeo: "",
// EnTitleSeo: "",
// ArTitleSeo: "",
// KeywordSeo: "",
// EnKeywordSeo: "",
// ArKeywordSeo: "",
// DescriptionSeo: "",
// EnDescriptionSeo: "",
// ArDescriptionSeo: "",
// CanonicalTagSeo: "",
// Redirect3xx: "",

function SeoProduct({ newSeoProduct, setSeoProduct }) {
  const handleChange = (e) => {
    const { value, name } = e.target;

    setSeoProduct({ ...newSeoProduct, [name]: value });
  };

  return (
    <SeoProductStyle>
      <SeoWrapper>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              name={"TitleSeo"}
              onChange={handleChange}
              label={"عنوان"}
            />
          </RowElement>
          <RowElement>
            <InputField1
              name={"EnTitleSeo"}
              onChange={handleChange}
              label={"عنوان انگلیسی"}
            />
          </RowElement>
          <RowElement>
            <InputField1
              name={"ArTitleSeo"}
              onChange={handleChange}
              label={"عنوان عربی"}
            />
          </RowElement>
        </RowLayoutStyle>
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              name={"KeywordSeo"}
              onChange={handleChange}
              label={"کلمات "}
            />
          </RowElement>
          <RowElement>
            <InputField1
              name={"EnKeywordSeo"}
              onChange={handleChange}
              label={"کلمات انگلیسی"}
            />
          </RowElement>
          <RowElement>
            <InputField1
              name={"ArKeywordSeo"}
              onChange={handleChange}
              label={"کلمات عربی"}
            />
          </RowElement>
        </RowLayoutStyle>
        <RowLayoutStyle>
          <SimpleTextArea
            name={"DescriptionSeo"}
            label={"توضیحات فارسی"}
            onChange={handleChange}
            rows={4}
          />
        </RowLayoutStyle>
        <RowLayoutStyle>
          <SimpleTextArea
            name={"EnDescriptionSeo"}
            onChange={handleChange}
            label={"توضیحات انگلیسی"}
            rows={4}
          />
        </RowLayoutStyle>
        <RowLayoutStyle>
          <SimpleTextArea
            name={"ArDescriptionSeo"}
            label={"توضیحات عربی"}
            onChange={handleChange}
            rows={4}
          />
        </RowLayoutStyle>
        <RowDiv>
          <InputField1
            name={"CanonicalTagSeo"}
            onChange={handleChange}
            label={"تگ"}
          />
          <InputField1
            name={"Redirect3xx"}
            onChange={handleChange}
            label={"Redirect3xx"}
          />
        </RowDiv>
      </SeoWrapper>
    </SeoProductStyle>
  );
}

const SeoProductStyle = styled.div`
  background-color: ${({ theme }) => theme.backgroundSidebar};
  width: 100%;
  position: relative;
`;

const SeoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem 1.5rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 1rem;
`;

export default SeoProduct;
